import type { NavigateFunction, NavigateOptions } from "react-router-dom";

export const RECORD_RETURN_TO_PARAM = "return_to";

const isSafeInternalPath = (value: string | null | undefined) => {
    if (!value) return false;

    const trimmedValue = value.trim();
    if (!trimmedValue.startsWith("/") || trimmedValue.startsWith("//")) return false;
    if (trimmedValue.startsWith("/\\")) return false;
    if (/[\u0000-\u001f]/.test(trimmedValue)) return false;
    if (trimmedValue.toLowerCase().includes("javascript:")) return false;

    return true;
};

export const getCurrentInternalPath = () => {
    if (typeof window === "undefined") return "";

    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

export const getSafeReturnToPath = (value: string | null | undefined) => (
    isSafeInternalPath(value) ? String(value).trim() : null
);

export const getReturnToFromCurrentLocation = () => {
    if (typeof window === "undefined") return null;

    return getSafeReturnToPath(new URLSearchParams(window.location.search).get(RECORD_RETURN_TO_PARAM));
};

export const appendReturnToParam = (target: string, returnTo = getCurrentInternalPath()) => {
    const safeReturnTo = getSafeReturnToPath(returnTo);
    if (!safeReturnTo) return target;

    const baseUrl = typeof window === "undefined" ? "http://primum.local" : window.location.origin;
    const url = new URL(target, baseUrl);
    url.searchParams.set(RECORD_RETURN_TO_PARAM, safeReturnTo);

    return `${url.pathname}${url.search}${url.hash}`;
};

export interface ReturnNavigationOptions extends NavigateOptions {
    fallback?: string | null;
}

export const navigateToReturnTarget = (
    navigate: NavigateFunction,
    options: ReturnNavigationOptions = {}
) => {
    const { fallback = null, ...navigateOptions } = options;
    const target = getReturnToFromCurrentLocation() || getSafeReturnToPath(fallback);

    if (target) {
        navigate(target, navigateOptions);
        return true;
    }

    return false;
};
